import { z } from "zod/v4";

import { ShopifyBulkOperationDtoSchema } from "../../../dtos/shopify";

export const RequestBulkOperationRequestBodySchema = z.object({
  startDatetime: z.string(),
  endDatetime: z.string(),
  type: z.enum(["orders"]),
});

export type RequestBulkOperationRequestBodyType = z.infer<
  typeof RequestBulkOperationRequestBodySchema
>;

export const RequestBulkOperationResponseBodySchema = z.object({
  operation: ShopifyBulkOperationDtoSchema,
});

export type RequestBulkOperationResponseBodyType = z.infer<
  typeof RequestBulkOperationResponseBodySchema
>;
